import { createContext } from 'react';

const initialValues = {
    fullPath: [],
    folderArchitecture: [],
    onOpenFolder: (folderId) => {},
    fetchFolderArchitecture: () => {},
};

const FileExplorerContext = createContext(initialValues);

export default FileExplorerContext;
